import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Download, X } from "lucide-react";
import { useApp } from "@/context/AppContext";

// Zeigt ein Banner zum Installieren der PWA (Android/Chrome beforeinstallprompt).
export const InstallBanner = () => {
  const { t } = useApp();
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(
    () => localStorage.getItem("vk_install_dismissed") === "1"
  );

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferred(e);
    };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setDeferred(null);
  };

  const close = () => {
    setDismissed(true);
    localStorage.setItem("vk_install_dismissed", "1");
  };

  const show = deferred && !dismissed;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12 }}
          className="mb-6 flex items-center gap-3 rounded-2xl border border-primary/30 bg-primary/5 p-4"
          data-testid="install-banner"
        >
          <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center shrink-0">
            <Download className="w-5 h-5 text-primary-foreground" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-sm">{t("installTitle")}</p>
            <p className="text-xs text-muted-foreground">{t("installDesc")}</p>
          </div>
          <button
            data-testid="install-accept-btn"
            onClick={install}
            className="h-9 px-4 rounded-lg bg-primary text-primary-foreground text-sm font-semibold hover:brightness-110 active:scale-95 transition-all shrink-0"
          >
            {t("install")}
          </button>
          <button
            data-testid="install-dismiss-btn"
            onClick={close}
            className="w-8 h-8 flex items-center justify-center rounded-lg text-muted-foreground hover:bg-secondary transition-colors shrink-0"
            aria-label={t("later")}
          >
            <X className="w-4 h-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
